export default {
  rewards: {
    title: "보상",
    claim: "받기",
    weeklyCashback: "주간 캐시백",
    weeklyCashbackDesc: "매주 손실의 일부를 돌려받으세요.",
    dailySpin: "매일 스핀",
    dailySpinDesc: "매일 룰렛을 돌려 큰 상품을 획득할 기회를 잡으세요.",
    invitationBonus: "초대 보너스",
    invitationBonusDesc: "친구를 초대하고 참여할 때마다 보상을 받으세요.",
    rebate: "리베이트",
    rebateDesc: "이기든 지든 모든 베팅에서 리베이트를 받으세요.",
    bannerTitle: "보상",
    bannerSubtitle: "임무를 완료하고 놀라운 보상을 획득하세요!",
    sectionTitle: "당신의 놀라운 보상",
    goNow: "지금 가기",
    historyReceived: "누적 수령",
    todayReceived: "오늘 수령",
    cashbackDialog: {
      title: "베팅 캐시백",
      loading: "불러오는 중...",
      empty: "캐시백 규칙이 없습니다",
      level: "등급",
      amountRange: "금액 범위",
      rewardRate: "보상 비율",
      rewardCap: "보상 한도",
    },
    cards: {
      checkin: {
        title: "일일 체크인",
        subtitle: "로그인 후 매일 체크인",
        description: "플레이어 여러분, 매일 체크인 잊지 마세요~",
      },
      cashback: {
        title: "캐시백",
        subtitle: "플랫폼 리베이트 보상",
      },
      rescue: {
        title: "구제 보너스",
        subtitle: "캐시 게임 3번 플레이",
        description: "파산한 플레이어를 위한 구제 자금",
      },
      task: {
        title: "임무",
        subtitle: "플랫폼 임무 완료",
        description: "플랫폼 임무",
      },
      balance: {
        title: "금고",
        subtitle: "매일 이자 획득",
        description: "플랫폼 금고",
      },
      loan: {
        title: "대출 보너스",
        subtitle: "간편한 대출",
        description: "플랫폼 대출",
      },
    },
    checkIn: {
      dailySignIn: "일일 체크인",
      totalRewards: "총 보상",
      headlineDaysBefore: "",
      headlineDaysAfter: "일 동안 체크인,",
      headlineTailCumulative: "하루 빠져도 괜찮습니다.",
      headlineTailDate: "하루 빠지면 그 날의 보상을 잃습니다.",
      headlineCumulative: "{days}일 체크인하고 큰 상 획득, 하루 빠져도 괜찮습니다.",
      headlineDate: "{days}일 체크인, 하루 빠지면 그 날의 보상을 잃습니다.",
      headlineEmpty: "체크인하여 보상 받기",
      title: "체크인",
      modeCumulative: "누적 체크인",
      modeDate: "날짜별 체크인",
      rewards: "보상",
      signedIn: "체크인 완료",
      day: "{n}일차",
      loading: "로딩 중...",
      empty: "진행 중인 체크인 활동이 없습니다.",
      btnCheckIn: "체크인",
      btnSigned: "완료",
      btnLocked: "잠김",
      claimSuccess: "체크인 성공, 보상 {amount} {currency} 지급됨",
      claimFailed: "체크인 실패",
      alreadySigned: "오늘 이미 체크인했습니다",
      notLogin: "먼저 로그인해주세요",
    },
  },
};
